import React from 'react';
import { Introduction, Tiles } from 'pages/Advices';
import Container from '@material-ui/core/Container';
import { Grid } from '@material-ui/core';

const Advices = () => (
  <Container>
    <Grid container justify="center">
      <Grid item xs={11}>
        <Introduction /> <Tiles />
      </Grid>
    </Grid>
  </Container>
);

export default Advices;
